import { useStores } from 'hooks';
import { observer } from 'mobx-react-lite';
import React from 'react';
import styled, { css } from 'styled-components';
import { BLACK, MessageWrapper, RED, WHITE, getBlinkingText } from '../Styles';
import { DeleteLogButton } from './DeleteLogButton';

export const PayloadInfo = observer(() => {
  const {
    DebuggerStore: {
      getSimLogSize,
      logCount,
      maxLogStorageSize,
      simLogTooLarge,
    },
  } = useStores();

  if (logCount === 0) return null;
  const logTooBig = simLogTooLarge();

  const remainingSizeInKb = `${(maxLogStorageSize - getSimLogSize()).toFixed(
    2,
  )} KB`;

  const payloadText = logTooBig
    ? `MAX SIZE REACHED`
    : `Log Size: ${remainingSizeInKb} REMAIN`;

  return (
    <Container flashColor={BLACK} maxed={logTooBig} triggerFlash={true}>
      {payloadText}
      {logTooBig && <DeleteLogButton />}
    </Container>
  );
});

export default PayloadInfo;

const Container = styled(MessageWrapper)`
  min-width: 200px;
  ${({ maxed, triggerFlash, flashColor }) =>
    maxed &&
    css`
      ${getBlinkingText(triggerFlash, flashColor)};
      background-color: ${RED};
      color: ${WHITE};
    `}

  && ${MessageWrapper} {
    height: 40px;
    margin-left: 15px;
  }
`;
